// extracted by mini-css-extract-plugin
export default {"totalsWrapper":"TotalsRow-module__totalsWrapper___H87kB"};